import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const FileUploadFinish = ({ className = '' }) => (
  <svg width="24" height="24" className={className}>
    <g fill="none" fillRule="evenodd">
      <g stroke={Colors.success}>
        <path fill="#E5F5F2" d="M.5.5v22h16V4.207L12.793.5H.5z" />
        <path d="M12.5 0v4.5H17" />
      </g>
      <path
        fill={Colors.success}
        d="M7.218 14.54l-3.096-3.104L3 12.676 7.309 17 14 9.145 12.79 8z"
      />
    </g>
  </svg>
);

FileUploadFinish.propTypes = {
  className: PropTypes.string
};

export default FileUploadFinish;
